<template>
  <div class="c-le-topbar u-px u-py" :class="`c-le-topbar--${courseSlug}`">
    <BackButton type="unit"
      :slug="unitSlug"
      :name="unitName"  />
    <Breadcrumbs class="c-le-topbar__breadcrumbs u-px"
      :crumbs="crumbs" />
    <LanguageSelect v-if="langs && langs.length > 1" :langs="langs" />
    <User />
  </div>
</template>

<script>
import { ref, onMounted, computed } from '@vue/composition-api'
import { fetchUnitBySlug } from '@/services/strapi'
import { mergeUnits } from '@/utils'
import BackButton from '@/components/BackButton'
import Breadcrumbs from '@forlagshuset/v-breadcrumbs'
import User from '@/components/User'
import LanguageSelect from '@/components/LanguageSelect'

export default {
  components: {
    BackButton,
    Breadcrumbs,
    User,
    LanguageSelect
  },

  props: {
    unitSlug: String,
    unitName: String,
    lessonSlug: String,
    lessonName: String,
    elementSlug: String,
    elementName: String,
  },

  setup(props, ctx) {
    const courseSlug = computed(() => ctx.root.$store.state.appConfig.slug)
    const crumbs = ref([])
    const langs = computed(() => ctx.root.$store.getters['appConfig/getAppLangs'])
    const unitIndex = ref('')

    onMounted (async () => {
      //extract util in EP-310
      const units = ctx.root.$store.getters['content/getUnits']
      const unit = await fetchUnitBySlug(props.unitSlug)
      const unitList = mergeUnits(units)
      unitList.forEach((parent, i) => {
        if (!parent.teacherUnit) {
          if(unit.parent && parent.id === unit.parent.id) {
            parent.units.forEach((child, j) => {
              if (child.slug === props.unitSlug) {
                unitIndex.value = j + 1
              }
            })
          } else {
            if (parent.slug === props.unitSlug) {
              unitIndex.value = i + 1
            }
          }
        }
      })
      let unitLink = '', lessonLink = '', unitType = ''

      if (props.unitSlug.indexOf('fagstoff') > -1) {
        unitType = 'fagstoff'
        unitLink = ''
        lessonLink = props.lessonSlug
      } else {
        unitType = 'unit'
        unitLink = props.unitSlug
        lessonLink = props.unitSlug + '?lesson=' + props.lessonSlug
      }

      crumbs.value.push({
        type: unitType,
        name: props.unitName,
        slug: unitLink,
        index: unitIndex.value
      })
      if (props.lessonName) {
        crumbs.value.push({
          type: unitType,
          name: props.lessonName,
          slug: lessonLink
        })
      }
      if (props.elementName && props.lessonSlug) {
        crumbs.value.push({
          type: '',
          name: props.elementName,
          slug: props.lessonSlug + '/' + props.elementSlug
        })
      }
    })

    return {
      courseSlug,
      crumbs,
      langs
    }
  }
}
</script>
